import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { AlternativeType, EtaStateType } from "../../../../../common-deprecated/types/CommonTypes";

export const initialState: EtaStateType = {
    loading: false,
    loaded: false,
    error: false,
    date: false,
    alternatives: [],
};

export type CarConfigEtaActionTypes = ReturnType<typeof startEtaLoad | typeof finishEtaLoad | typeof resetEta>;

export const CarConfigEtaSlice = createSlice({
    name: "eta",
    initialState,
    reducers: {
        startEtaLoad(state) {
            return { ...state, loading: true, loaded: true, error: false };
        },
        finishEtaLoad(
            state,
            action: PayloadAction<{ eta: { date: string | false; alternatives: AlternativeType[] } }>,
        ) {
            return { ...state, ...action.payload.eta, loading: false, loaded: true };
        },
        resetEta(state, action: PayloadAction<boolean>) {
            return {
                ...initialState,
                error: action.payload,
            };
        },
    },
});

export const { startEtaLoad, finishEtaLoad, resetEta } = CarConfigEtaSlice.actions;
